import { useCallback, useEffect, useState } from 'react';
import { getAuthToken } from '../services/auth';
import { AUTH_STORAGE_CHANGED_EVENT } from '../services/storage';

type AuthSessionState = {
  isAuthenticated: boolean;
  loading: boolean;
  token: string | null;
};

export const useAuthSession = () => {
  const [state, setState] = useState<AuthSessionState>({
    isAuthenticated: false,
    loading: true,
    token: null,
  });

  const refreshSession = useCallback(async () => {
    const response = await getAuthToken();
    const token =
      response.success && typeof response.data === 'string'
        ? response.data
        : null;

    setState({
      isAuthenticated: Boolean(token),
      loading: false,
      token,
    });
  }, []);

  useEffect(() => {
    refreshSession();

    const handleStorageChange = () => {
      refreshSession();
    };

    window.addEventListener(AUTH_STORAGE_CHANGED_EVENT, handleStorageChange);
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener(
        AUTH_STORAGE_CHANGED_EVENT,
        handleStorageChange,
      );
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [refreshSession]);

  return {
    ...state,
    refreshSession,
  };
};
